/**
 * Auth endpoint wrappers — the saas-auth cookie-bearing surface.
 *
 * `refresh` runs on cold boot and on every bounded 401 retry; `logout` is fired
 * by the sign-out action. Both go through `request` (cookie surface), so they
 * carry `credentials:'include'` and the CSRF double-submit automatically.
 */
import { request } from './client';
import type { AuthTokenResponse } from './types';

export const authApi = {
  refresh(): Promise<AuthTokenResponse> {
    return request<AuthTokenResponse>('POST', '/api/auth/refresh', { json: {} });
  },

  logout(): Promise<void> {
    return request<void>('POST', '/api/auth/logout', { json: {} });
  },
};
